// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"93a8c2d4","693":"737acb30"}[chunkId] + ".chunk.css";
};